export const painPoints = [
  {
    emoji: '🧭',
    title: 'Vous ne savez pas par où commencer',
    desc: "L'alphabet coréen semble impossible et vous êtes submergé par l'endroit où débuter. Cette méthode organise tout : d'abord les bases, puis le pratique, puis le conversationnel.",
  },
  {
    emoji: '🔤',
    title: 'Vous vous bloquez avec le Hangeul (et tout sonne pareil)',
    desc: 'Vous l’apprenez ici de manière guidée, donc vous reconnaissez les motifs et prononcez avec intention. Plus de confusion entre les lettres et les sons similaires.',
  },
  {
    emoji: '🧩',
    title: 'Vous connaissez des mots aléatoires mais ne pouvez pas former de phrases',
    desc: 'Vous apprenez la structure de phrase de base pour construire des phrases qui ont réellement du sens et commencer à communiquer dès le jour un.',
  },
  {
    emoji: '💭',
    title: 'Vous étudiez mais oubliez rapidement',
    desc: 'Vous obtenez des conseils concrets de mémorisation et des routines de rétention afin que ce que vous étudiez reste dans votre cerveau au lieu de s’effacer en une semaine.',
  },
  {
    emoji: '🎬',
    title: 'Vous regardez les K-Dramas et ne comprenez rien',
    desc: 'Les sous-titres font tout le travail et vous ne captez jamais un seul mot réel. Ici, vous entraînez votre oreille avec les expressions qui apparaissent réellement à l’écran.',
  },
  {
    emoji: '🔁',
    title: 'Vous avez commencé une app et arrêté après deux semaines',
    desc: 'Les séries ne sont pas du progrès. Un plan quotidien de 60 minutes avec des étapes visibles est ce qui vous permet d’avancer jusqu’à comprendre votre première vraie conversation.',
  },
];
